/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2021 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

const PREVIOUS_MENU_NOT_DEFINED = null;

export class UnsavedDataService {

  constructor() {
    this.previousMenuItem = PREVIOUS_MENU_NOT_DEFINED;
  }

  isDataSaveNeeded(currentSelectedMenuItem) {
    this.isCurrentSelectedMenuItemNavPage = currentSelectedMenuItem.isNavPage;
    if (this.previousMenuItem != PREVIOUS_MENU_NOT_DEFINED &&
        !this.previousMenuItem.isNavPage && 
        !currentSelectedMenuItem.isOpenInNewWindow &&
        window.doNavigateForAppTririga) {

      //Call navigate save logic generated from gwt.
      window.doNavigateForAppTririga();
      if (window.shouldCancelNavigateForAppTririga) {
          return true;
      } 
    }
    //Set previous page
    this.previousMenuItem = currentSelectedMenuItem;
    return false;
  }
  
}